import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/named
import { updatePreviousShot } from '../../../model/configuratorSlice';

const ImagePlayer = () => {
  const {
    settings, currentShot, previousShot, isGeneralShot,
  } = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  const [visibleImage, setVisibleImage] = useState('image-two');
  const [imageOneShot, setImageOneShot] = useState(null);
  const [imageTwoShot, setImageTwoShot] = useState(null);

  let pendingCurrentShot = null;

  const tryToUpdateImages = () => {
    if (pendingCurrentShot !== null) {
      pendingCurrentShot = null;
      if (visibleImage === 'image-one') {
        setImageTwoShot(currentShot);
      } else {
        setImageOneShot(currentShot);
      }
      dispatch(updatePreviousShot(currentShot));
    }
  };

  useEffect(() => {
    if (currentShot != null && currentShot !== previousShot) {
      pendingCurrentShot = currentShot;
      tryToUpdateImages();
    }
  }, [currentShot]);

  const onImageOneTransitionEnd = () => {
    if (visibleImage === 'image-two') {
      setImageOneShot(null);
    } else {
      tryToUpdateImages();
    }
  };

  const onImageTwoTransitionEnd = () => {
    if (visibleImage === 'image-one') {
      setImageTwoShot(null);
    } else {
      tryToUpdateImages();
    }
  };

  const onImageOneLoaded = () => {
    setVisibleImage('image-one');
  };

  const onImageTwoLoaded = () => {
    setVisibleImage('image-two');
  };

  const getClassNameForImageRendererContainer = (currentImage) => {
    let className = 'image-renderer-container';
    if (visibleImage === currentImage) {
      className += ' active';
      if (isGeneralShot) {
        className += ' general';
      }
    }

    return className;
  };

  return (
    <>
      <div
        className={getClassNameForImageRendererContainer('image-one')}
        onTransitionEnd={onImageOneTransitionEnd}
      >
        {imageOneShot === null ? null : (
          <img
            src={`${settings.shots_base_url}/${imageOneShot}.jpg`}
            onLoad={onImageOneLoaded}
            alt=""
          />
        )}
      </div>
      <div
        className={getClassNameForImageRendererContainer('image-two')}
        onTransitionEnd={onImageTwoTransitionEnd}
      >
        {imageTwoShot === null ? null : (
          <img
            src={`${settings.shots_base_url}/${imageTwoShot}.jpg`}
            onLoad={onImageTwoLoaded}
            alt=""
          />
        )}
      </div>
    </>
  );
};

export default ImagePlayer;
